<script lang="ts">
	import { onDestroy } from "svelte";
	import { isFiltersUpdating } from "../../stores/stores.filters";
	import { formObjectStores } from "../../stores/stores.searchform";
	import { FilterStores } from "../../../types/types.serpPage";
	import { sortFiltersValues } from "../../modules/sortFilters.serpPage";
	import { Unsubscriber } from "svelte/store";
	import { msg } from "../../modules/utils.serpPage";
	import { CONFIG_SERP_PAGE as CONFIG } from "../../serpPage.config";
	const { MANAGE_TIMEOUT } = CONFIG.SEARCHES;

	let filters: FilterStores[] = [];
	let setTimeoutInstance: number | undefined;
	let timeoutInstance: number | undefined;
	$: filteredFilters = sortFiltersValues(filters.filter((filter) => filter.currentValues?.length));

	const formObjectStoresUnsubscribe: Unsubscriber = formObjectStores.subscribe((form) => {
		filters = form.filters;
	});

	const isFiltersUpdatingUnsubscribe: Unsubscriber = isFiltersUpdating.subscribe((isUpdate) => {
		if (isUpdate) {
			clearTimeout(timeoutInstance);
			timeoutInstance = setTimeout(() => {
				formObjectStores.refreshFilters();
			}, MANAGE_TIMEOUT);
		}
	});

	type ValueChangedEvent = CustomEvent<{ filter: FilterStores; value: string }>;
	function valueChanged(event: ValueChangedEvent) {
		clearTimeout(setTimeoutInstance);
		setTimeoutInstance = setTimeout(() => {
			formObjectStores.updateValueFilter(event.detail.filter.symbol, event.detail.value);
		}, 500);
	}

	onDestroy(() => {
		isFiltersUpdatingUnsubscribe();
		formObjectStoresUnsubscribe();
	});
</script>

{#if filteredFilters.length > 0}
	<div class="collapse-wrapper-lg sidebarWrapper">
		<a class="btn-collapse sidebarCollapseButton text-decoration-none fs-6 fw-bold collapsed" data-bs-toggle="collapse" href="#filtersWrapper" role="button" aria-expanded="false" aria-controls="filtersWrapper">
			{msg("filters")}
			<svg class="d-lg-none bsCollapseIcon" aria-hidden="true" viewBox="0 0 20 20" width="20" height="20" xmlns="http://www.w3.org/2000/svg">
				<use href="#ic-arrow-down" xlink:href="#ic-arrow-down" />
			</svg>
		</a>
		<div class="collapse border-top" id="filtersWrapper">
			<ul class="d-flex flex-column list-unstyled m-0">
				{#each filteredFilters as filter}
					<li class="filter" data-filter-type={filter.typeProp} data-filter={filter.name}>
						<svelte:component this={filter.component} {filter} on:valueChanged={valueChanged} />
					</li>
				{/each}
			</ul>
		</div>
	</div>
{/if}
